import R from 'ramda'

const COMMENTS_ON_DISPLAY_TYPE = 'Comments On Post'
const EXISTING_POST_TRIGGER_TYPES = ['IG_INITIAL_POST', 'COMMENTS_ON']

const hasValidTriggerType = R.flip(R.contains)
const isCommentsOnWidgetTrigger = R.pipe(
  R.prop('type'),
  hasValidTriggerType(EXISTING_POST_TRIGGER_TYPES)
)

const constructExistingPostFormData = R.applySpec({
  type: R.always(COMMENTS_ON_DISPLAY_TYPE),
  action: R.always('EXISTING_POST'),
  value: R.prop('data')
})

const isExistingPost = R.propEq('type', 'COMMENTS_ON')
const isImageInitialPost = R.pathSatisfies(R.equals('image'), ['data', 'type'])
const isVideoInitialPost = R.pathSatisfies(R.equals('video'), ['data', 'type'])

const constructNewImagePostFormData = widget => {
  const mediaType = R.pathOr(
    undefined,
    ['data', 'searchParams', 'media_type'],
    widget
  )
  const isStory = mediaType === 'STORIES'
  return R.applySpec({
    type: R.always(COMMENTS_ON_DISPLAY_TYPE),
    action: R.always('NEW_POST_IMAGE'),
    postText: R.path(['data', 'searchParams', 'caption']),
    imageUrl: R.path(['data', 'searchParams', 'image_url']),
    isStory: R.always(isStory)
  })(widget)
}

const constructNewVideoPostFormData = widget => {
  const mediaType = R.pathOr(
    undefined,
    ['data', 'searchParams', 'media_type'],
    widget
  )
  const isStory = mediaType === 'STORIES'
  return R.applySpec({
    type: R.always(COMMENTS_ON_DISPLAY_TYPE),
    action: R.always('NEW_POST_VIDEO'),
    postText: R.path(['data', 'searchParams', 'caption']),
    videoUrl: R.path(['data', 'searchParams', 'video_url']),
    isStory: R.always(isStory)
  })(widget)
}

const convertCommentsOnWidgetTriggerToFormTrigger = R.cond([
  [isExistingPost, constructExistingPostFormData],
  [isImageInitialPost, constructNewImagePostFormData],
  [isVideoInitialPost, constructNewVideoPostFormData]
])

export {
  isCommentsOnWidgetTrigger,
  convertCommentsOnWidgetTriggerToFormTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/instagram/widget-to-form/comments-on.js